import './App.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/home.jsx';
import Upload from './pages/upload.jsx';
import Settings from './pages/settings.jsx';
import SideNavbar from './components/sidenavbar.jsx';
import Users from './pages/users.jsx';
import Login from './pages/login.jsx';
import Modules from './pages/module.jsx';
import { useAuth } from './context/AuthContext';

function App() {
  const { user, loading } = useAuth();

  const ProtectedRoute = ({ children }) => {
    if (loading) {
      return (
        <div className="min-h-screen flex items-center justify-center text-slate-200">
          Loading...
        </div>
      );
    }

    return user ? children : <Navigate to="/login" replace />;
  };

  const PublicRoute = ({ children }) => {
    if (loading) {
      return (
        <div className="min-h-screen flex items-center justify-center text-slate-200">
          Loading...
        </div>
      );
    }

    return user ? <Navigate to="/home" replace /> : children;
  };

  return (
    <div className="App flex min-h-screen bg-slate-950 text-slate-100">
      {user && <SideNavbar />}
      <div className="flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<Navigate to={user ? '/home' : '/login'} replace />} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
          <Route path="/module" element={<ProtectedRoute><Modules /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to={user ? '/home' : '/login'} replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
